import React, { useContext } from 'react';
import { useLabels } from 'wsm-common-data';
import { setClassNames } from 'ddc-classnames-js';
import { ResultsContext } from '../contexts';

const NoResults = () => {
	const { didRequestTimeout, requestTimeoutType } =
		useContext(ResultsContext);
	const labels = useLabels();

	let message = labels.get('SORRY_NO_RESULTS');

	if (didRequestTimeout) {
		const fallbackLabel = labels.get('SORRY_TIMEOUT_GENERIC');

		switch (requestTimeoutType) {
			case 'add': {
				message = labels.get('SORRY_TIMEOUT_ADD');
				break;
			}
			case 'inventory': {
				message = labels.get('SORRY_TIMEOUT_INVENTORY');
				break;
			}
			case 'pages': {
				message = labels.get('SORRY_TIMEOUT_PAGES');
				break;
			}
			default: {
				message = labels.get('SORRY_TIMEOUT_GENERIC');
				break;
			}
		}

		// Handle any undefined labels
		message = message || fallbackLabel;
	}

	return (
		<div
			data-testid="sts-no-results"
			aria-live="polite"
			aria-atomic="true"
			role="alert"
		>
			<div className={setClassNames(['p-4', 'text-body'])}>
				<strong>{message}...</strong>
			</div>
		</div>
	);
};

export default NoResults;
